export default {
  leave: {},
  isBusy: false,
};
